<script>
    import { preventDefault } from "svelte/legacy";
    import { createEventDispatcher } from "svelte";
    import tagService from "../service.js";
    import { notificate } from "../../../services/notification.js";
    import { flatten422Errors, search } from "../../../services/api.svelte.js";
    import { translateErrorMessages } from "../../../services/api.svelte.js";
    import vulnerabilityService from "../../vulnerability/service.js";
    import AssetsApi from "../../asset/assets.api.js";
    import { format, locale } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    let {
        tag,
        vulnerabilitiesAssociated = $bindable([]),
        parent = "list",
    } = $props();

    let formData = {};
    let formDataPromise;
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    // API 422 errors
    let formApiErrors = {};
    let vulnerabilities = [];
    let search_results;
    let showDropdown = false;
    let vulnerabilitiesToRemove = [];
    let is_edit;

    // add form
    if (!tag) {
        formDataPromise = Promise.resolve({});
        is_edit = false;
    }
    // edit form
    else {
        formData = {
            name: tag.name,
        };
        is_edit = true;
        if (vulnerabilitiesAssociated.length <= 0 && tag.vulnerability) {
            // FIX: Safely extract vulnerability whether it's a string or a PowerTable object wrapper
            let rawVuln = tag.vulnerability?.vulnerability || tag.vulnerability;
            if (typeof rawVuln === "string") {
                try {
                    vulnerabilitiesAssociated = JSON.parse(rawVuln);
                } catch (e) {
                    vulnerabilitiesAssociated = [];
                }
            } else {
                vulnerabilitiesAssociated = Array.isArray(rawVuln) ? [...rawVuln] : [rawVuln];
            }
        }
    }

    const hydrateVulnerabilities = async (vulnerabilitiesData) => {
        // FIX: Extract actual data to prevent JSON.parsing an object
        let raw = vulnerabilitiesData?.vulnerability || vulnerabilitiesData;
        let vulsArray = typeof raw === "string" ? JSON.parse(raw) : raw;
        
        let vulnerabilities = JSON.parse(JSON.stringify(vulsArray)); // Safe deep clone
        
        if (vulnerabilities && vulnerabilities.length > 0 && vulnerabilities[0]) {
            for (let vul of vulnerabilities) {
                if (!vul.title) vul.title = "";
                if (!vul.title_es) vul.title_es = vul.title;
                vul.name = vul.title_es || vul.title;
            }
        }
        return vulnerabilities;
    };

    function handleSubmit() {
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        let reqData = {};

        if (vulnerabilitiesToRemove.length > 0) {
            for (let vulnerability of vulnerabilitiesToRemove) {
                reqData = {
                    tag_id: tag.id,
                    target_object_type: "Vulnerability",
                    target_object_id: vulnerability.id,
                };
                tagService
                    .deleteAssociation(reqData, [], {})
                    .then(async (savedTag) => {
                        dispatch("save", { tag });
                        formData = {};
                        formIsSubmitted = false;
                        formApiErrors = {};
                        return true;
                    })
                    .catch((errors) => {
                        if (typeof errors.detail == "string") {
                            APIerror = translateErrorMessages(
                                errors.detail,
                                "Etiquetas",
                            );
                        } else {
                            formApiErrors = flatten422Errors(errors);
                        }
                        return false;
                    });
            }
        } else {
            // Close even if nothing was removed
            dispatch("save", { tag });
        }
    }
    
    const removeAssociatedVulnerability = (i) => {
        vulnerabilitiesToRemove.push(vulnerabilitiesAssociated[i]);
        vulnerabilitiesAssociated.splice(i, 1);
        vulnerabilitiesAssociated = vulnerabilitiesAssociated;
    };

    function handleCloseModal() {
        formData = {};
        formApiErrors = {};
        formIsSubmitted = false;
        showDropdown = true;
        APIerror = null;
        vulnerabilities = [];
        search_results = [];
        dispatch("closeModal");
    }

    const handleKeydown = (event) => {
        if (event.key == "Escape") {
            handleCloseModal();
        } else {
            return;
        }
    };
</script>

<svelte:window onkeydown={handleKeydown} />

<form role="form" novalidate onsubmit={preventDefault(handleSubmit)}>
    <div class="card">
        <div class="card-body">
            {#if tag}
                <div class="mb-3">
                    <label for="name"
                        >{$format("form.fields.name")}<span class="text-danger"
                            >*</span
                        ></label
                    >
                    <span class="d-block">{tag.name}</span>
                </div>
                {#if parent == "list"}
                    {#if tag.vulnerability && (tag.vulnerability.length > 0 || tag.vulnerability.vulnerability?.length > 0)}
                        {#await hydrateVulnerabilities(tag.vulnerability) then success}
                            <label for="associatedVulnerabilities"
                                >{$format(
                                    "page.tag.associated_vulnerabilities",
                                )}:</label
                            >
                            {#if vulnerabilitiesAssociated.length > 0}
                                {#each vulnerabilitiesAssociated as vulnerability, i}
                                    <div>
                                        {$locale == "es"
                                            ? vulnerability.title_es
                                            : vulnerability.title}
                                        <i
                                            class="fas fa-times btnDeleteVulnerability float-end"
                                            onclick={() =>
                                                removeAssociatedVulnerability(
                                                    i,
                                                )}
                                        ></i>
                                    </div>
                                {/each}
                            {/if}
                        {/await}
                    {/if}
                {:else}
                    <label for="associatedVulnerabilities"
                        >{$format(
                            "page.tag.associated_vulnerabilities",
                        )}:</label
                    >
                    {#each vulnerabilitiesAssociated as vulnerability, i}
                        <div>
                            {vulnerability.title_es || vulnerability.title}<i
                                class="fas fa-times btnDeleteVulnerability float-end"
                                onclick={() =>
                                    removeAssociatedVulnerability(
                                        i,
                                    )}
                            ></i>
                        </div>
                    {/each}
                {/if}
            {/if}
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary t-submit-tag-btn"
                >{$format("buttons.save")}</button
            >
            <button
                type="button"
                class="btn btn-default"
                data-bs-dismiss="modal"
            >
                {$format("buttons.cancel")}
            </button>
        </div>
    </div>
</form>

<style>
    .btnDeleteVulnerability {
        cursor: pointer;
    }
</style>